import { dashboardFilterOptions } from '../../constants/app.constants';
import { dashboardActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  error: '',

  botPerformanceData: {
    data: {},
    message: '',
  },
  sunBurstChartData: {
    data: [],
    message: '',
  },
  lineGraphData: {
    data: null,
    message: '',
  },
  companyOnboardingLineGraphData: {
    data: null,
    message: '',
  },
  barGraphData: {
      data: [],
    message: '',
  },
    scheduledProcessPercentageData: {
      data: {},
    message: '',
  },
  filter: {
    [dashboardFilterOptions.Company]: [],
    [dashboardFilterOptions.Bot]: []
  },
};
const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.BOTPERFORMANCE_START_FETCH:
      return { ...state, loading: true };

    case ACTION.FETCH_BOTPERFORMANCE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        botPerformanceData: {
          ...state.botPerformanceData,
          data: action.payload,
          message: '',
        },
        error: '',
      };
    case ACTION.BOTPERFORMANCE_SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.FETCH_BOTPERFORMANCE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        botPerformanceData: {
          data: {},
          message: action.payload,
        },
        error: '',
      };
    case ACTION.REMOVE_BOTPERFORMANCE_DATA:
      return {
        ...state,
        botPerformanceData: {
          ...state.botPerformanceData,
          data: {},
        },
      };
    case ACTION.LINEGRAPH_START_FETCH:
      return { ...state, loading: true };

    case ACTION.COMPANY_ONBOARDING_LINE_GRAPH_START_FETCH:
      return { ...state, loading: true };

    case ACTION.FETCH_LINEGRAPH_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        lineGraphData: {
          ...state.lineGraphData,
          data: action.payload,
          message: '',
        },
        error: '',
      };
    case ACTION.FETCH_COMPANY_ONBOARDING_LINE_GRAPH_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        companyOnboardingLineGraphData: {
          ...state.companyOnboardingLineGraphData,
          data: action.payload,
          message: '',
        },
        error: '',
      };
    case ACTION.LINEGRAPH_SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.FETCH_LINEGRAPH_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        lineGraphData: {
          data: [],
          message: action.payload,
        },
        error: '',
      };
    case ACTION.FETCH_COMPANY_ONBOARDING_LINE_GRAPH_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        companyOnboardingLineGraphData: {
          data: [],
          message: action.payload,
        },
        error: '',
      };
    case ACTION.REMOVE_LINEGRAPH_DATA:
      return {
        ...state,
        lineGraphData: {
          ...state.lineGraphData,
          data: [],
        },
      };
    case ACTION.SUNBURST_START_FETCH:
      return { ...state, loading: true };

    case ACTION.FETCH_SUNBURST_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        sunBurstChartData: {
          ...state.sunBurstChartData,
          data: action.payload,
          message: '',
        },
        error: '',
      };
    case ACTION.SUNBURST_SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.FETCH_SUNBURST_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        sunBurstChartData: {
          data: {},
          message: action.payload,
        },
        error: '',
      };
    case ACTION.REMOVE_SUNBURST_DATA:
      return {
        ...state,
        sunBurstChartData: {
          ...state.sunBurstChartData,
          data: {},
        },
      };
    case ACTION.DASHBOARD_FILTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case ACTION.DASHBOARD_FILTER_SUCCESS:
      const { key, values } = action.payload;
      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          [key]: [...values],
        },
      };
    case ACTION.DASHBOARD_FILTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      case ACTION.BARGRAPH_START_FETCH:
      return { ...state, loading: true };


    case ACTION.FETCH_BARGRAPH_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        barGraphData: {
          ...state.barGraphData,
          data: action.payload,
          message: '',
        },
        error: '',
      };
       case ACTION.BARGRAPH_SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.FETCH_BARGRAPH_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        barGraphData: {
          data: [],
          message: action.payload,
        },
        error: '',
      };
      case ACTION.SCHEDULED_PERCENTAGE_START_FETCH:
      return { ...state, loading: true };


    case ACTION.FETCH_SCHEDULED_PERCENTAGE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        scheduledProcessPercentageData: {
          ...state.scheduledProcessPercentageData,
          data: action.payload,
          message: '',
        },
        error: '',
      };
       case ACTION.SCHEDULED_PERCENTAGE_SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.FETCH_SCHEDULED_PERCENTAGE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        scheduledProcessPercentageData: {
          data: [],
          message: action.payload,
        },
        error: '',
      };
    default:
      return state;
  }
};
export default dashboardReducer;
